export const API_BASE_URL = "https://lensburyapi.24bluedoor.com"